import { Heading, InfoButton, Para, Stack } from '@drycut/ui-components';

import type { BookingCheckoutProps } from '../BookingCheckout';

import { useCheckoutStore } from '../checkoutStore';
import StepIndicator from '../StepIndicator';
import { SalonSelect } from './SalonSelect';
import WaitingTimeDetails from './WaitingTimeDetails';

type Props = {
  storeSlug?: BookingCheckoutProps['storeSlug'];
};

export function Step1({ storeSlug }: Props): React.ReactElement {
  const selectedStore = useCheckoutStore((state) => state.selectedStore);

  return (
    <>
      <StepIndicator index={1}>Salon {!storeSlug && ' wählen'}</StepIndicator>

      {storeSlug ? (
        <Heading variant="h4" className="font-ramillas text-start">
          DRYCUT {selectedStore?.name}
        </Heading>
      ) : (
        <SalonSelect />
      )}

      {selectedStore && <WaitingTimeDetails store={selectedStore} />}

      <Stack
        gap={3}
        direction="row"
        className="bg-primary-50 border-2 border-gray-200 p-2 items-start"
      >
        <Para size="xs">
          Um ein gutes Resultat zu garantieren, bitte beachte unsere "clean hair policy". (gewaschen
          & keine Produkte)
        </Para>

        <InfoButton
          title="Clean hair policy"
          text="Haare sollten keine oder wenig Produkte (Gel, Pomade, etc.) enthalten und in den vergangenen 24 Stunden gewaschen worden sein."
          className="z-20"
        />
      </Stack>
    </>
  );
}
